import { SummaryDetail } from '@/types/summary'
import { Author, Evaluation, Genre, Price, Publisher, Rating, Release } from '.'

interface Props {
  summary: SummaryDetail
  onClick?: () => void
}
export const Property: React.FC<Props> = ({ summary, onClick }) => {
  return (
    <div className="flex-1 text-[15px] leading-9">
      <div onClick={onClick}>
        <Genre categories={summary.categories} />
        <div className="pc">
          <Author authors={summary.authors} />
        </div>
        <Publisher
          name={summary.publisher.name}
          link={summary.publisher_link}
        />
        <div className="sm:flex">
          <Price price={summary.price} />
          <Release date={summary.release} />
        </div>
        <Rating score={summary.score} />
      </div>
      <Evaluation />
    </div>
  )
}
